import { render, staticRenderFns } from "./personList.vue?vue&type=template&id=49693a3c&scoped=true&"
import script from "./personList.vue?vue&type=script&lang=js&"
export * from "./personList.vue?vue&type=script&lang=js&"
import style0 from "./personList.vue?vue&type=style&index=0&id=49693a3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49693a3c",
  null
  
)

export default component.exports